import { getCountryCallingCode } from 'libphonenumber-js';
export var getDiallingCode = function getDiallingCode(countryCode) {
  try {
    return "+".concat(getCountryCallingCode(countryCode));
  } catch (_unused) {
    return '';
  }
};